import React from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import './index.css';
import Home from './pages/home';
import ServiceA from './pages/serviceA';
import ServiceB from './pages/serviceB';
import ServiceC from './pages/serviceC';
import ServiceD from './pages/serviceD';
import ServiceE from './pages/serviceE';
import ServiceF from './pages/serviceF';
import Demo from './pages/demo';
import Contact from './pages/contact';
import Services from './pages/services';
import Careers from './pages/careers';
import App from './App';
import Opportunities from './pages/opportunities';
import ScrollToTop from './components/scroll';
import NoMatch from './pages/404';
import Login from './pages/login';
import Msg from './pages/msg';
import Review from './pages/review';
import Referrals from './pages/referralManagement';
import Referral from './pages/referral';
import Recruit from './pages/recruit';
import TeamM from "./pages/teamManagement";
import Dashboard from './pages/staff';
import NoAuth from './pages/noAuth';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute'; 
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
Amplify.configure(awsExports);


const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);


root.render(
  <React.StrictMode>
     <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/home" element={<Home />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/referral" element={<Referral />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/opportunities" element={<Opportunities />} />
        <Route path="/services/positive-behaviour-support-practitioner" element={<ServiceA />} />
        <Route path="/services/occupational-therapist" element={<ServiceB />} />
        <Route path="/services/support-coordination" element={<ServiceC />} />
        <Route path="/services/disability-support-worker" element={<ServiceD />} />
        <Route path="/services/supported-independent-living" element={<ServiceE />} />
        <Route path="/services/social-worker" element={<ServiceF/>} />
        <Route path="/login" element={<Login />} />
        <Route path="/noauth" element={<NoAuth />} />
        <Route path="*" element={<NoMatch />} />
        <Route path="/admin/*" element={
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate replace to="msg" />} /> 
            <Route path="msg" element={<ProtectedRoute element={<Msg />} />} />
            <Route path="review" element={<ProtectedRoute element={<Review />} />} />
            <Route path="recruit" element={<ProtectedRoute element={<Recruit />} />} />
            <Route path="dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
            <Route path="referrals" element={<ProtectedRoute element={<Referrals />} />} />
            <Route path="team" element={<ProtectedRoute element={<TeamM />} />} />
            <Route path="*" element={<NoMatch />} />
          </Routes>
        </AuthProvider>
        } />
      </Routes>
    </Router>
  </React.StrictMode>
);
